import $ from 'jquery'
import CONSTS from '../constants'
import Component from './component'

export class AddProduct extends Component {
  constructor(ctx, ev) {
    super(ctx, ev)

    // classes extensions
    Object.assign(this.classes, {
      form: '.js-add-product-form',
      quantity: '.js-add-product-quantity',
      quantityChange: '.js-add-product-quantity-change',
      quantityInput: '.js-add-product-quantity-input',
      subTotal: '.js-add-product-subtotal',
      detail: '.js-add-product-detail',
      notification: '.js-add-product-notification',
      showLoginLink: '.js-add-product-show-login',
    })

    this.fallbackMinValue = 1
    this.fallbackMaxValue = 200

    this.bindQuantityChange()
    this.bindQuantityInputs()
    this.bindProductFormSubmit()
    this.bindShowLogin()
  }

  bindQuantityChange() {
    this.$ctx.on('click', this.classes.quantityChange, (event) => {
      event.preventDefault()

      const RADIX = 10
      const $me = $(event.currentTarget)
      const type = $me.data('type')
      const $quantity = $me.closest(this.classes.quantity)
      const $quantityInput = $quantity.find(this.classes.quantityInput)
      const currentValue = window.parseInt($quantityInput.val(), RADIX)
      let minValue = window.parseInt($quantityInput.attr('min'), RADIX)
      let maxValue = window.parseInt($quantityInput.attr('max'), RADIX)

      if (!minValue) {
        minValue = this.fallbackMinValue
      }

      if (!maxValue) {
        maxValue = this.fallbackMaxValue
      }

      if (!isNaN(currentValue)) {
        if (type === 'minus') {
          if (currentValue > minValue) {
            $quantityInput.val(currentValue - 1).change()
          }

          if (window.parseInt($quantityInput.val(), RADIX) === minValue) {
            $me.attr('disabled', true)
          }
        } else if (type === 'plus') {
          if (currentValue < maxValue) {
            $quantityInput.val(currentValue + 1).change()
          }

          if (window.parseInt($quantityInput.val(), RADIX) === maxValue) {
            $me.attr('disabled', true)
          }
        }
      } else {
        $quantityInput.val(0)
      }
    })
  }

  bindQuantityInputs() {
    this.$ctx.on('focusin', this.classes.quantityInput, (event) => {
      const $me = $(event.currentTarget)

      $me.data('oldValue', $me.val())
    })

    this.$ctx.on('change', this.classes.quantityInput, (event) => {
      const $me = $(event.currentTarget)

      const $form = $me.closest('form')
      const $subTotal = $form.find(this.classes.subTotal)

      const $quantity = $me.closest(this.classes.quantity)
      const $btnMinus = $quantity.find('[data-type="minus"]')
      const $btnPlus = $quantity.find('[data-type="plus"]')
      const RADIX = 10

      let currentValue = window.parseInt($me.val(), RADIX) // = quantity
      let minValue = window.parseInt($me.attr('min'), RADIX)
      let maxValue = window.parseInt($me.attr('max'), RADIX)
      const price = $form.data('price')

      if (!minValue) {
        minValue = this.fallbackMinValue
      }

      if (!maxValue) {
        maxValue = this.fallbackMaxValue
      }

      if (currentValue > minValue) {
        $btnMinus.removeAttr('disabled')
      }

      if (currentValue < minValue) {
        $me.val($me.data('oldValue'))
      }

      if (currentValue <= maxValue) {
        $btnPlus.removeAttr('disabled')
      } else {
        $me.val($me.data('oldValue'))
      }

      // update subtotal
      const DECIMALS = 2
      currentValue = window.parseInt($me.val(), RADIX)
      $subTotal.html(
        this.numberFormat(price * currentValue, DECIMALS, '.', "'")
      )
    })

    this.$ctx.on('keydown', this.classes.quantityInput, (event) => {
      const KEY_BACKSPACE = 46
      const KEY_DELETE = 8
      const KEY_TAB = 9
      const KEY_ESCAPE = 27
      const KEY_ENTER = 13
      const KEY_DOT = 190
      const KEY_CTRL_A = 65

      if (
        // Allow: backspace, delete, tab, escape, enter and .
        $.inArray(event.keyCode, [
          KEY_BACKSPACE,
          KEY_DELETE,
          KEY_TAB,
          KEY_ESCAPE,
          KEY_ENTER,
          KEY_DOT,
        ]) !== -1 ||
        // Allow: Ctrl+A
        (event.keyCode === KEY_CTRL_A && event.ctrlKey === true) ||
        // Allow: home, end, left, right
        // eslint-disable-next-line no-magic-numbers
        (event.keyCode >= 35 && event.keyCode <= 39)
      ) {
        // let it happen, don't do anything
        return
      }

      if (
        // Ensure that it is a number and stop the keypress
        // eslint-disable-next-line no-magic-numbers
        (event.shiftKey || event.keyCode < 48 || event.keyCode > 57) &&
        // eslint-disable-next-line no-magic-numbers
        (event.keyCode < 96 || event.keyCode > 105)
      ) {
        event.preventDefault()
      }
    })
  }

  numberFormat(number, decimals, decPoint, thousandsSep) {
    number = `${number}`.replace(/[^0-9+\-Ee.]/g, '')
    const n = !isFinite(Number(number)) ? 0 : Number(number)
    const prec = !isFinite(Number(decimals)) ? 0 : Math.abs(decimals)
    const sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep
    const dec = typeof decPoint === 'undefined' ? '.' : decPoint
    let s = ''

    // eslint-disable-next-line func-style
    const toFixedFix = function (n, prec) {
      // eslint-disable-next-line no-magic-numbers
      const k = Math.pow(10, prec)

      return `${(Math.round(n * k) / k).toFixed(prec)}`
    }

    s = (prec ? toFixedFix(n, prec) : `${Math.round(n)}`).split('.')

    // eslint-disable-next-line no-magic-numbers
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }

    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length + 1).join('0')
    }

    return s.join(dec)
  }

  bindShowLogin() {
    this.$ctx.on('click', this.classes.showLoginLink, (event) => {
      event.preventDefault()

      this.ev.emit(CONSTS.EVENTS.SHOW_LOGIN)
    })
  }

  bindProductFormSubmit() {
    this.$ctx.on('submit', this.classes.form, (event) => {
      event.preventDefault()

      const RADIX = 10
      const $form = $(event.currentTarget)
      const $quantityInput = $form.find(this.classes.quantityInput)
      const quantity = window.parseInt($quantityInput.val(), RADIX)
      const $detail = $form.closest(this.classes.detail)
      const $notification = $detail.find(this.classes.notification)

      $.ajax({
        type: 'POST',
        data: $form.serialize(),
        dataType: 'json',
        url: $form.attr('action'),
        success: (data) => {
          if (data.status === 'success') {
            this.showNotification($notification, $quantityInput)

            this.ev.emit(CONSTS.EVENTS.UPDATE_CART_QUANTITY, quantity)
          }
        },
        error: () => false,
      })
    })
  }

  showNotification($notification, $quantityInput) {
    const DELAY = 2000

    $notification.show()
    $quantityInput.val(1).change()
    window.setTimeout(() => $notification.hide(), DELAY)
  }

  onResize() {
    // noop
  }
}
